module.exports = __webpack_public_path__ + "static/media/icon_referral.f3aa3b3a.svg";